import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
/////////////////////////////////////////////////////////////

interface MenuItemProps {
	path: string;
	name: string;
	icon: string | undefined;
	isEnabled: boolean;
	isComingSoon: boolean;
}

export const MenuItem: React.FC<MenuItemProps> = ({
	path,
	name,
	icon,
	isEnabled,
	isComingSoon,
}: MenuItemProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	 * 
	// #region Template
	**********************/

	if (process.env.VITE_APP_NAME !== 'Vottun Dojo' && !isEnabled) return null;

	return (
		<li className="mx-6 py-4 border-b border-customer-200">
			<Link
				to={isEnabled ? path : ''}
				className={`flex items-center gap-4 flex-1`}
			>
				<img src={icon} className="w-[25px] drop-shadow-lg" />
				<p
					className={`uppercase text-base ${
						isComingSoon ? 'text-[#999]' : ''
					}`}
				>
					{name}
				</p>
				{isComingSoon && (
					<span className="text-right ml-auto text-[9px] bg-clip-text bg-gradient-to-r text-transparent from-yellow-100 via-yellow-500 to-yellow-800 rounded-lg text-black p-1 flex-1">
						{t('general.comingSoon')}
					</span>
				)}
			</Link>
		</li>
	);
};
